export default [
  {
    header: 'userManagement.administration',
    permission: ['user_management'],
    unique_name: 'administration-users',
  },
  {
    title: 'userManagement.title',
    route: 'users-list',
    icon: 'UserIcon',
    permission: ['user_management'],
    unique_name: 'administration-users',
  },
  {
    title: 'permissions',
    route: 'permissions',
    icon: 'SettingsIcon',
    unique_name: 'administration-permissions',
  },
]